import { Router } from "@frui.ts/screens/dist";
import PaymentRetryViewModel, { PaymentRetryNavigationName } from "./paymentRetryViewModel";

export const MultiPaymentRetryNavigationName = PaymentRetryNavigationName;

@Router.registerRoute({ route: `${MultiPaymentRetryNavigationName}/:orderId`, name: Router.Self })
export default class MultiPaymentRetryViewModel extends PaymentRetryViewModel {}
